export const NAV_LINKS = [
  { label: "Protection", href: "/#services" },
  { label: "Manifesto", href: "/#manifesto" },
  { label: "Network", href: "/#network" },
  { label: "Dashboard", href: "/#dashboard" },
  { label: "Blog", href: "/blog" },
  { label: "Contact", href: "/#contact" },
];

export const SERVICES = [
  {
    id: "malware",
    slug: "malware-detection",
    tag: "01",
    title: "Malware Detection & Prevention",
    desc: "Behavioral engines locate, quarantine and neutralize threats before they touch your origin. Zero-day heuristics running at the edge.",
    span: "md:col-span-8",
    accent: "#22D3EE",
  },
  {
    id: "privacy",
    slug: "privacy-shield",
    tag: "02",
    title: "Privacy Shield",
    desc: "Encrypt every hop. Strip trackers. Keep your users invisible.",
    span: "md:col-span-4",
    accent: "#FACC15",
  },
  {
    id: "theft",
    slug: "theft-prevention",
    tag: "03",
    title: "Theft Prevention",
    desc: "Credential-stuffing walls and identity anomaly detection that stop account takeover cold.",
    span: "md:col-span-4",
    accent: "#F43F5E",
  },
  {
    id: "cheat",
    slug: "game-cheat-detection",
    tag: "04",
    title: "Real-Time Game Cheat Detection",
    desc: "Sub-frame telemetry catches aimbots, wallhacks and injectors the instant they load. Fair play, enforced in real time.",
    span: "md:col-span-8",
    accent: "#22D3EE",
  },
  {
    id: "cloud",
    slug: "cloud-servers",
    tag: "05",
    title: "Cloud Servers",
    desc: "Elastic compute wrapped in the sphere. Deploy anywhere, protected everywhere.",
    span: "md:col-span-6",
    accent: "#FACC15",
  },
  {
    id: "proxy",
    slug: "cdn",
    tag: "06",
    title: "Reverse Proxy & CDN",
    desc: "Sitting between users and origin, Endasphere accelerates, caches and hardens every request across our global backbone.",
    span: "md:col-span-6",
    accent: "#22D3EE",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    head: "Everything inside the sphere is protected.",
    body: "We don't bolt security on. We wrap it around. Sites, apps, APIs and players live inside a perimeter that never sleeps.",
  },
  {
    n: "02",
    head: "The edge is the new frontline.",
    body: "312 locations. One intent. We intercept threats where they originate, not after they breach your walls.",
  },
  {
    n: "03",
    head: "Connectivity should feel like nothing.",
    body: "The best infrastructure is invisible. Faster routes, lower latency, zero friction between your users and your origin.",
  },
];

export const INTERESTS = [
  { value: "general", label: "General inquiry" },
  { value: "security", label: "Malware & privacy" },
  { value: "gaming", label: "Game cheat detection" },
  { value: "cloud", label: "Cloud & CDN" },
  { value: "enterprise", label: "Enterprise infrastructure" },
];

export const IMAGES = {
  serverRoom: "https://images.unsplash.com/photo-1782094673136-5198a372980c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  network: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  mesh: "https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  padlock: "https://images.unsplash.com/photo-1614064548237-096f735f344f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gaming: "https://images.pexels.com/photos/7862505/pexels-photo-7862505.jpeg?auto=compress&cs=tinysrgb&w=1600",
};
